import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import TextTooltipContent from '../../../Popover/_partials/TextTooltipContent';
import Button from '../../../Button';
import s from './CommentTooltip.scss';
var CommentTooltip = function (_a) {
    var className = _a.className, children = _a.children, onDismiss = _a.onDismiss;
    return (React.createElement(SimplePopperPopover, { className: classnames(s['content'], className), placement: "top", secondaryPlacement: "start", portalClassName: s['portal'], usePortal: true, showArrow: true, popoverContent: React.createElement(TextTooltipContent, { textClassName: s['text'], tooltipText: 
            /* prettier-ignore */
            React.createElement(Trans, { i18nKey: "actionbar.comment.tooltip" },
                "Thanks for downloading. Show the artist some love!",
                React.createElement(Button, { view: "b34", onClick: onDismiss, className: s['dismiss-btn'], biData: BiData({
                        evid: 105,
                        sectionname: 'download_popup',
                        typeid: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        creatorid: BiContextProvidedValue,
                        sectionid: BiContextProvidedValue,
                        section_typeid: BiContextProvidedValue,
                        sectiontype: BiContextProvidedValue,
                        sectionrank: BiContextProvidedValue,
                        rank: BiContextProvidedValue,
                        sort_type: BiContextProvidedValue,
                        reason_shown: BiContextProvidedValue,
                        widgetname: BiContextProvidedValue,
                    }) }, "Leave a comment")) }) }, children));
};
CommentTooltip.displayName = 'CommentTooltip';
export default CommentTooltip;
//# sourceMappingURL=CommentTooltip.js.map